"use client";

import { ArrowDownIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

export function SwitchTokensButton({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) {
  return (
    <div className="relative z-10 flex justify-center">
      <Button
        type="button"
        variant="secondary"
        size="icon"
        onClick={onClick}
        disabled={disabled}
        aria-label="Switch token positions"
        className="group/switch -my-4 rounded-xl border-4 border-background shadow-sm transition-transform duration-200 hover:scale-110 hover:text-primary active:scale-90"
      >
        <ArrowDownIcon className="transition-transform duration-300 group-hover/switch:rotate-180" />
      </Button>
    </div>
  );
}
